import { Injectable } from '@angular/core';
import { Platform } from '@ionic/angular'; 
import { FirebaseAnalytics } from '@ionic-native/firebase-analytics/ngx';
// Firebase Web SDK imports
import { initializeApp } from 'firebase/app';
import { getAnalytics, logEvent as webLogEvent, setUserProperties, setUserId as webSetUserId } from 'firebase/analytics';
/*
  Generated class for the AnalyticsProvider provider.
cd 
  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class AnalyticsProvider {
  // Firebase web analytics references
  private static firebaseApp: any = null;
  private static analytics: any = null;

  // TODO: Replace with your actual Firebase config for web

  private firebaseConfig = {
 
  apiKey: "AIzaSyBpuG1d4B47ZXuEs-rpBAv8m5bFed7ZpPU",
  authDomain: "centuryprevileges.firebaseapp.com",
  projectId: "centuryprevileges",
  appId: "1:109399482147:web:d9d69cdf7b86ae94e4f696",
  measurementId: "G-JPEBQWTMT6"
 
};

  constructor(private firebaseX: FirebaseAnalytics, private platform: Platform) {
    this.platform.ready().then(() => {
      if (!this.platform.is('cordova')) {
        if (!AnalyticsProvider.firebaseApp) {
          AnalyticsProvider.firebaseApp = initializeApp(this.firebaseConfig);
          AnalyticsProvider.analytics = getAnalytics(AnalyticsProvider.firebaseApp);
        }
      }
    });
  }

  logEvent(name: string, properties: object) {
    this.platform.ready().then(() => {
      if (this.platform.is('cordova')) {
        this.firebaseX.logEvent(name, properties)
          .then(data => {
            console.log(data)
          })
          .catch(err => {
            console.log(err)
          })
      } else {
        if (AnalyticsProvider.analytics) {
          webLogEvent(AnalyticsProvider.analytics, name, properties);
        } else {
          console.log("Firebase analytics not initialized for web.");
        }
      }
    });
  }

  setUserProperty(key: string, value: string) {
    this.platform.ready().then(() => {
      if (this.platform.is('cordova')) {
        this.firebaseX.setUserProperty(key, value).then(data => console.log(data)).catch(err => {
          console.log(err)
        });
      } else {
        if (AnalyticsProvider.analytics) {
          setUserProperties(AnalyticsProvider.analytics, { [key]: value });
        }
      }
    });
  }

  // Tracks a 'screen_view' event in Firebase Analytics
  trackScreen(name: string) {
    this.platform.ready().then(() => {
      if (this.platform.is('cordova')) {
        this.firebaseX.setCurrentScreen(name).then(data => {
          console.log(data);
        }).catch(err => {
          console.log(err)
        })
      } else {
        if (AnalyticsProvider.analytics) {
          webLogEvent(AnalyticsProvider.analytics, 'screen_view' as string, { firebase_screen: name });
        }
      }
    });
  }

  setUserId(uid: string) {
    this.platform.ready().then(() => {
      if (this.platform.is('cordova')) {
        this.firebaseX.setUserId(uid).then(data => {
          console.log(data);
        }).catch(err => {
          console.log(err)
        })
      } else {
        if (AnalyticsProvider.analytics) {
          webSetUserId(AnalyticsProvider.analytics, uid);
        }
      }
    });
  }

  setEnabled(val: boolean) {
    this.platform.ready().then(() => {
      if (this.platform.is('cordova')) {
        this.firebaseX.setEnabled(val).then(data => {
          console.log(data);
        }).catch(err => {
          console.log(err)
        })
      } else {
        // Not directly supported in web SDK, but you can implement your own logic if needed
        console.log('setEnabled is not supported for Firebase Web Analytics.');
      }
    });
  }
}
